import ChromeCastPlugin from '@silvermine/videojs-chromecast';
import vjsNamespace from 'video.js';
import Player from 'video.js/dist/types/player';

const CAST_SENDER_SCRIPT =
  'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
let injectorPromise: Promise<boolean>;
function injectCastSender(): Promise<boolean> {
  if (injectorPromise) {
    return injectorPromise;
  }
  injectorPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'application/javascript';
    script.async = true;
    script.src = CAST_SENDER_SCRIPT;
    script.addEventListener('load', () => resolve(true));
    script.addEventListener('error', () => reject(false));
    document.body.appendChild(script);
  });

  return injectorPromise;
}

export function initChromecastPlugin(vjs: typeof vjsNamespace) {
  ChromeCastPlugin(vjs, { preloadWebComponents: false });
  injectCastSender().then((_) => _);
}

/**
 * The plugin we use keeps track of the casting state in a static property of the sessionManager
 * Unfortunately, that static property is not cleared when the player is disposed.
 * If we try to instantiate another player and the flag is set to true, the chromecast "Tech" will be wrongly
 * initialized and selected by the player, which will result in a crash.
 * To fix that, we have to clear the sessionManager.hasConnected flag when we dispose of the player.
 */
function resetChromecastSessionManager(player: any) {
  if (!player.chromecastSessionManager) {
    return;
  }

  const manager = player.chromecastSessionManager;
  // We follow the prototype chain to get to the original class so we can
  // access it's static properties
  const ChromecastSessionManager = Object.getPrototypeOf(manager).constructor;
  if (ChromecastSessionManager.hasConnected) {
    ChromecastSessionManager.hasConnected = false;
    //_savedChromecastSessionManager = manager;
  }
}

export function setupChromecastForPlayer(player: Player) {
  // @ts-ignore
  player.chromecast({
    receiverAppID: 'CC1AD845', // <== chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID, but chrome.cast.media is not ready by the time we call this
  });
  //@ts-ignore
  player.on('dispose', () => resetChromecastSessionManager(player));
}
